// 所有特效都會放在這邊
const initState = {
  miniCartData: [],
  cartListData: {},
  cartCouponModalData: [],
  isShowCouponModal: false,
};

export function cartState(state = initState, action) {
  switch (action.type) {
    // header購物車信息
    case 'UPDATE_MINICARTDATA_DATA': {
      return {
        ...state,
        miniCartData: action.payload,
      };
    }
    case 'UPDATE_CART_LIST_DATA': {
      return {
        ...state,
        cartListData: action.payload,
      };
    }
    case 'UPDATE_IS_SHOW_COUPON_LIST_MODAL': {
      return {
        ...state,
        isShowCouponModal: action.payload,
      };
    }
    default:
      return state;
  }
}

export default cartState;
